if (!customElements.get('pc-delivery')) {
  class PcDelivery extends HTMLElement {
    static parse(value) {
      if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return null;
      const [y,m,d] = value.split('-').map(Number);
      const date = new Date(y,m-1,d,12);
      return date.getFullYear() === y && date.getMonth() === m-1 && date.getDate() === d ? date : null;
    }
    static iso(date) { return `${date.getFullYear()}-${String(date.getMonth()+1).padStart(2,'0')}-${String(date.getDate()).padStart(2,'0')}`; }
    static deadline(value,days=5) { const date=this.parse(value); if(!date)return ''; let remaining=Math.max(0,Math.floor(Number(days)||5)); while(remaining){date.setDate(date.getDate()-1);if(date.getDay()!==0 && date.getDay()!==6)remaining--;}return this.iso(date); }
    connectedCallback() {
      this.eventInput=this.querySelector('[data-event]');
      this.abort=new AbortController();
      const today=PcDelivery.iso(new Date()); this.eventInput.min=today;
      this.addEventListener('change',()=>this.update(),{signal:this.abort.signal});
      this.update();
    }
    disconnectedCallback(){this.abort?.abort();}
    format(value){const date=PcDelivery.parse(value);return date ? date.toLocaleDateString('ro-RO',{day:'numeric',month:'short'}) : '—';}
    update(){
      const today=PcDelivery.iso(new Date());
      const earliest=PcDelivery.deadline(this.eventInput.value,5);
      this.eventInput.min=today;
     
      this.eventInput.setCustomValidity('');
      const eventValid=Boolean(PcDelivery.parse(this.eventInput.value)) && this.eventInput.validity.valid;
      this.querySelector('[data-recommendation]').hidden=!eventValid || (earliest<today && !this.dataset.confirmationMessage);
      this.querySelector('[data-estimated-date]').textContent=eventValid?(earliest>=today?`Primire estimată: ${this.format(earliest)}`:this.dataset.confirmationMessage):'';
      this.querySelector('[data-estimate-help]').textContent=eventValid && earliest<today?'':'Cu 5 zile lucrătoare înainte de eveniment (luni–vineri).';
      const estimate=this.querySelector('[data-estimated-value]');estimate.value=eventValid && earliest>=today?earliest:'';estimate.disabled=!estimate.value;
      this.error(this.eventInput,this.eventInput.value?this.message(this.eventInput):'');
    }
    error(input,message){input.setAttribute('aria-invalid',String(Boolean(message)));const node=input===this.eventInput?this.querySelector('[data-event-error]'):this.querySelector('[data-arrival-error]');node.textContent=message;node.hidden=!message;}
    message(input){
      if(!input.value)return '';
      if(!PcDelivery.parse(input.value))return 'Alege o dată validă.';
      if(input.value<input.min)return 'Data nu poate fi în trecut.';
      return input.validity.valid?'':'Alege o dată validă.';
    }
    validate(){
      this.update();
      let first=null;
      for(const input of [this.eventInput]){
        if(input.disabled) continue;
        input.setCustomValidity('');
        const message=this.message(input);
        this.error(input,message);input.setCustomValidity(message);if(message&&!first)first=input;
      }
      if(first){const disclosure=this.querySelector('details');if(disclosure)disclosure.open=true;first.scrollIntoView({block:'center',behavior:'smooth'});first.focus({preventScroll:true});return false;}return true;
    }
  }
  customElements.define('pc-delivery',PcDelivery);
}
